import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '@/contexts/AppContext';
import { useAuth } from '@/contexts/AuthContext';
import { WifiOff, Wifi, ArrowLeft, Camera } from 'lucide-react';
import { Button } from '@/components/ui/button';

// GenerIA Brand Logo URL
const GENERIA_LOGO = "https://customer-assets.emergentagent.com/job_inspeccion-pwa/artifacts/qhvfjidw_IMG_8814.jpeg";

export const TopBar = ({ photoNumber = null }) => {
  const navigate = useNavigate();
  const { selectedProject, selectedConcept, isOnline } = useApp();
  const { user } = useAuth();

  const handleBack = () => {
    navigate('/catalogo');
  };

  return (
    <div className="bg-gradient-to-r from-[#040810] to-[#060C18] h-14 px-4 flex items-center justify-between shadow-lg border-b border-[#1E3550]" data-testid="top-bar">
      {/* Left: Back Button + Logo + Contract Name */}
      <div className="flex items-center gap-3">
        <Button
          variant="ghost"
          size="icon"
          onClick={handleBack}
          className="text-[#E2EAF4] hover:bg-[#1E3550]/50 h-9 w-9"
          data-testid="back-to-catalogo"
        >
          <ArrowLeft className="w-5 h-5" />
        </Button>
        <img src={GENERIA_LOGO} alt="GenerIA" className="h-8 w-8 object-contain" />
        <div>
          <h2 className="text-base font-semibold text-[#E2EAF4] tracking-wide" data-testid="contract-name">
            {selectedProject?.name || 'GenerIA'}
          </h2>
        </div>
      </div>

      {/* Center: Concept Info + Photo Number */}
      {selectedConcept && (
        <div className="flex items-center gap-4" data-testid="concept-info">
          <div className="text-center text-[#E2EAF4]">
            <span className="font-bold text-lg text-[#00CFFF]">{selectedConcept.clave}</span>
            <span className="mx-2 opacity-50">|</span>
            <span className="text-sm opacity-90">{selectedConcept.descripcion}</span>
          </div>
          <div className="bg-[#0066FF]/30 px-3 py-1 rounded border border-[#0066FF]/50">
            <span className="text-xl font-bold mono text-[#00CFFF]">{selectedConcept.unidad}</span>
          </div>
          {/* Photo Number - shown when available */}
          {photoNumber && (
            <div className="flex items-center gap-1.5 bg-[#FF6B00]/30 px-2.5 py-1 rounded text-xs font-semibold text-[#FF6B00] border border-[#FF6B00]/50" data-testid="photo-number">
              <Camera className="w-3.5 h-3.5" />
              <span>Foto {String(photoNumber).padStart(3, '0')}</span>
            </div>
          )}
        </div>
      )}

      {/* Right: Status & User */}
      <div className="flex items-center gap-3">
        {/* Sync Status */}
        <div className={`flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold ${
          isOnline ? 'bg-green-500/20 text-green-300 border border-green-500/30' : 'bg-red-500/20 text-red-300 border border-red-500/30'
        }`} data-testid="sync-status">
          {isOnline ? (
            <>
              <Wifi className="w-3.5 h-3.5" />
              <span>En línea</span>
            </>
          ) : (
            <>
              <WifiOff className="w-3.5 h-3.5" />
              <span>Offline</span>
            </>
          )}
        </div>

        {/* User Info */}
        <div className="text-right text-sm">
          <p className="font-semibold text-[#E2EAF4]">{user?.name}</p>
        </div>
      </div>
    </div>
  );
};
